import { useEffect } from 'react';
const SRC = 'https://embed.tawk.to/66d0d33650c10f7a00a1d1a0/1i6fri394';
declare global {
  interface Window {
    Tawk_API?: Record<string, unknown>;
    Tawk_LoadStart?: Date;
  }
}

/**
 * Carga el widget de chat de Tawk.to y lo fija abajo a la izquierda,
 * en el lugar que antes ocupaba la burbuja de WhatsApp.
 */
export function TawkToWidget() {
  useEffect(() => {
    if (document.querySelector(`script[src="${SRC}"]`)) return;
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();
    window.Tawk_API.customStyle = {
      visibility: {
        desktop: {
          position: 'bl',
          xOffset: 20,
          yOffset: 20
        },
        mobile: {
          position: 'bl',
          xOffset: 12,
          yOffset: 12
        }
      }
    };
    const script = document.createElement('script');
    script.async = true;
    script.src = SRC;
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    document.body.appendChild(script);
  }, []);
  return null;
}